module.exports = __webpack_public_path__ + "static/media/sophisticated-3.8e5e7053.png";